import { render, staticRenderFns } from "./BOListeFormations.vue?vue&type=template&id=1c121f0a"
import script from "./BOListeFormations.vue?vue&type=script&lang=js"
export * from "./BOListeFormations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports